import { createApp } from "vue";
import App from "./App.vue";

import "bootstrap/dist/css/bootstrap.min.css";
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import "bootstrap-icons/font/bootstrap-icons.css";

import { Quasar } from "quasar";
import quasarIconSet from "quasar/icon-set/material-icons";
import quasarLang from "quasar/lang/th"; // or 'en-US'
import "@quasar/extras/material-icons/material-icons.css";
import "quasar/src/css/index.sass";

import { Notify } from "quasar";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const app = createApp(App).use(router);
app.component("VueDatePicker", VueDatePicker);
app.component("v-select", VueSelect);

app.use(Quasar, {
  plugins: { Notify },
  iconSet: quasarIconSet,
  lang: quasarLang,
});

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import router from './router'
app.use(VueSweetalert2);

// import { VueDatePicker } from '@vuepic/vue-datepicker';
// import '@vuepic/vue-datepicker/dist/main.css'
// app.component('VueDatePicker', VueDatePicker);

app.mount("#app");
